import dayjs from 'dayjs'
import { EventsByDate, EventsByMonth, FormattedEvent, RawEvent } from '../types/Event'
import { DATE_FORMAT, PST_TZ } from '~constants'
import { filterPastEvents } from '../utils'
export class EventFormatter {
  constructor() {
    this.eventsByDate = {}
    this.formattedEvents = []
    this.eventsByMonth = {}
  }

  private formattedEvents: FormattedEvent[]
  private eventsByDate: EventsByDate
  private eventsByMonth: EventsByMonth

  getFormattedEvents() {
    return this.formattedEvents
  }

  getEventsByDate() {
    return this.eventsByDate
  }

  getEventsByMonth() {
    return this.eventsByMonth
  }

  formatEvent(event: RawEvent): FormattedEvent {
    //Convert the UTC time to PST using event timezne
    const local = dayjs.tz(event.date_time, event.timezone)
    const nowInSameTZ = dayjs().tz(event.timezone)
    return {
      id: event.id,
      name: event.name,
      dateTime: local.format(DATE_FORMAT.DATE_TIME),
      dateKey: local.format(DATE_FORMAT.SHORT_DATE_FORMAT),
      monthKey: local.format(DATE_FORMAT.YEAR_MONTH),
      timezone: event.timezone,
      // Shouldn't one of these be max?
      price: { min: event.price?.min ?? 0, max: event.price?.min ?? 0 },
      hostUrl: event?.host_url,
      isSoldOut: event?.is_sold_out,
      isPast: local.isBefore(nowInSameTZ),
      artistId: event.artists ? event.artists[0].id : '',
      artistName: event.artists ? event.artists[0].name : '',
      category: event.category && event.category?.length > 0 ? event.category[0]?.value : '',
      sphereFlags: event.sphere_flags ? event.sphere_flags : null
    }
  }

  formatAllEvents(rawData: any[]): FormattedEvent[] {
    return rawData
      ?.flatMap(item => item.events || [])
      .filter(Boolean)
      .map((event: RawEvent) => this.formatEvent(event))
  }

  groupByDate(events: FormattedEvent[]): EventsByDate {
    return events.reduce<EventsByDate>((acc, event) => {
      if (!acc[event.dateKey]) acc[event.dateKey] = []
      acc[event.dateKey].push(event)
      return acc
    }, {})
  }

  groupByMonthAndDate(events: FormattedEvent[]): EventsByMonth {
    return events.reduce<EventsByMonth>((acc, event) => {
      if (!acc[event.monthKey]) acc[event.monthKey] = {}
      if (!acc[event.monthKey][event.dateKey]) acc[event.monthKey][event.dateKey] = []
      acc[event.monthKey][event.dateKey].push(event)
      return acc
    }, {})
  }

  processEventEngineResponse(rawData: any[]): {
    formattedEvents: FormattedEvent[]
    eventsByDate: EventsByDate
    eventsByMonth: EventsByMonth
  } {
    const formattedEvents = this.formatAllEvents(rawData)
    this.formattedEvents = formattedEvents
    const eventsByDate = this.groupByDate(formattedEvents)
    const today = dayjs().tz(PST_TZ).format(DATE_FORMAT.SHORT_DATE_FORMAT)
    const filteredEventsByDate = { ...eventsByDate, [today]: filterPastEvents(eventsByDate[today] || []) }
    this.eventsByDate = filteredEventsByDate
    const eventsByMonth = this.groupByMonthAndDate(formattedEvents)
    this.eventsByMonth = eventsByMonth
    return { formattedEvents, eventsByDate: filteredEventsByDate, eventsByMonth }
  }
}
